import React, { useState } from "react";
import "./Header.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Logo from "../../assets/VPEX LOGO V V.png";
import Modal from "../Modal/Modal";
import { Link } from "react-router-dom";

const Header = () => {
  const [showModal, setShowModal] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const handleContactClick = () => {
    setShowModal(true);
    setExpanded(false); // Cerrar el menú cuando se abre el modal de contacto
  };

  const handleNavLinkClick = () => {
    setExpanded(false); // Cerrar el menú cuando se hace clic en un enlace de navegación
  };

  return (
    <>
      <Navbar
        fixed="top"
        expand="lg"
        expanded={expanded}
        className="bg-body-tertiary shadow"
        bg="dark"
        data-bs-theme="dark"
      >
        <Container>
          <Link className="a" to={"/"}>
            <img
              alt=""
              src={Logo}
              width="50"
              height="50"
              className="d-inline-block align-center"
            />{" "}
            VPEX
          </Link>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(!expanded)}
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Link
                className="text-light nav-links ms-3 mt-2"
                to={"/"}
                onClick={handleNavLinkClick}
              >
                Inicio{" "}
              </Link>
              {/* <Link
                className="text-light nav-links ms-3 mt-2"
                to={"/knowus"}
                onClick={handleNavLinkClick}
              >
                Conocenos
              </Link> */}
              <Link
                className="text-light nav-links ms-3 mt-2"
                to={"/development"}
                onClick={handleNavLinkClick}
              >
                Desarrollo
              </Link>
              <Link
                className="text-light nav-links ms-3 mt-2"
                to={"/infrastructure"}
                onClick={handleNavLinkClick}
              >
                Infraestructura
              </Link>
              <Link
                className="text-light nav-links ms-3 mt-2"
                to={"/faq"}
                onClick={handleNavLinkClick}
              >
                Ayuda
              </Link>
              <button className="btn-contact ms-3" onClick={handleContactClick}>
                Contacto
              </button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Modal show={showModal} setShow={setShowModal} />
    </>
  );
};

export default Header;
